
export default {
  RENDERHOST: 'https://static-files-concierge.staging.flybits.com/latest/zone.html',
  DEFAULTFLBHOST: 'https://api.demo.flybits.com',
  DEFAULTREFID: 'homepage',
  DEFAULTCTXREPORTINTERVAL: 2000
}